import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'app-common-product-change-update',
  templateUrl: './common-product-change-update.component.html',
  styleUrls: ['../parts.css']
})
export class CommonProductChangeUpdateComponent implements OnInit {

  boardData: any = {}; // 面板数据
  boardColumnData: Array<any> = []; // 面板表头数据
  boardGroupData: Array<any> = []; // 面板组数据

  situationVisible = false;
  situationOption = [];
  situationData;

  // 分组
  groupConditionVisible: boolean; // 分组POP是否关闭
  groupConditionId = null; // 分组选中ID
  groupConditionDisplayText = '分组'; // 条件二默认文字
  conditionData: any; // 存放条件筛选数据
  conditionVisible = false; // 条件pop

  selectionStart = 1;
  isVisible = false;
  isConfirmLoading = false;

  recipe;
  recipeId;
  relationId;
  categorieId;
  backFillData: any;
  instanceData: any = {}; // 存放实例返填数据
  automation = {
    boardId: '',
    groupId: '',
    relationId: '',
    categoryId: '',
    schedulerConfig: {},
    conditions: [],
    interfaceId: '',
    taskMapping: {}
  }; // 存放入参数据
  @ViewChild('pulseCard', { static: true }) pulseCard: any;
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
    }
    if (this.recipe && this.recipe.configurationFields) {
      if (this.recipe['configurationFields']['situations']) {
        this.situationOption = this.recipe['configurationFields']['situations'] || [];
      }
      if (this.recipe['configurationFields']['cron']) {
        this.automation.schedulerConfig = {
          type: 'realtime',
          cron: this.recipe.configurationFields.cron
        };
      } else {
        this.automation.schedulerConfig = {
          type: 'realtime',
          cron: '0 0/1 * * * ? '
        };
      }
    }
    // 处理实例数据
    if (this.instanceData && this.instanceData.config) {
      const config = this.instanceData.config;
      this.automation = JSON.parse(JSON.stringify(config));
      this.groupConditionId = this.automation.groupId;
      for (const group of this.boardGroupData) {
        if (group.id === this.groupConditionId) {
          this.groupConditionDisplayText = group.title;
        }
      }
      this.backFillData = config['taskMapping'];
      this.situationData = config['interfaceId'];
      for (const item of this.situationOption) {
        if (item.code === this.situationData) {
          this.conditionData = item.options || [];
          break;
        }
      }
    }
    // 带入菜单ID
    this.automation.categoryId = this.categorieId;
    this.automation.relationId = this.relationId;
    this.packageData(this.automation);
  }

  situationChange(item) {
    this.situationData = item.code;
    this.automation.interfaceId = item.code;
    this.conditionData = item.options || [];
    this.packageData(this.automation);
  }

  openTaskDialog() {
    this.isVisible = true;
  }

  getTaskIntegrationData(event) {
    // this.backFillData = event;
    const obj: any = {};
    event.forEach((item, index) => {
      let mapObj: any;
      if (typeof item.mappingValue === 'string') {
        switch (item.type) {
          case 'dropdown':
            mapObj = {
              'fixedValue': {
                'ids': [item.mappingValue]
              }
            };
            break;
          case 'select':
            mapObj = {
              'fixedValue': {
                'option': item.mappingValue
              }
            };
            break;
          case 'button':
            mapObj = {
              'fixedValue': {
                'original': item.mappingValue
              }
            };
            break;
        }
      }
      if (item.type === 'dropdown' || item.type === 'select' || item.type === 'button') {
        obj[item.id] = mapObj;
      } else {
        const mpArr = [];
        item.mappingValue.forEach((m, i) => {
          mapObj = {
            'type': 'field',
            'sourceField': {
              'id': m.id,
              'type': m.type ? m.type : 'text',
              'title': m.title
            }
          };
          mpArr.push(mapObj);
        });
        mpArr.unshift({'type': 'text', 'text': item.mappingFirstValue});
        mpArr.push({'type': 'text', 'text': item.mappingEndValue});
        obj[item.id] = {
          'targetField': {
            'id': item.id,
            'title': item.title,
            'type': item.type,
          },
          'mappingParts': mpArr
        };
      }
      this.automation.taskMapping['mappingConfig'] = obj;
    });
    this.packageData(this.automation);
  }

  handleOk() {
    this.pulseCard.onSubmit();
    this.isVisible = false;
  }

  groupConditionChange(item) {
    this.groupConditionDisplayText = item.title;
    this.groupConditionId = item.id;
    this.automation.groupId = this.groupConditionId;
    this.groupConditionVisible = false;
    this.packageData(this.automation);
  }

  getConditionData(data) {
    this.automation.conditions = data;
    this.packageData(this.automation);
  }

  // 组件提交数据
  packageData(data) {
    data.instanceDescription = '当新的 情况 出现且满足 条件 时，在 ' + this.groupConditionDisplayText + ' 中创建 任务';
    this.nfDataChange.emit(data);
  }

  getSubmitStatus(): boolean {
    return this.automation.interfaceId &&
      this.automation.conditions && this.automation.conditions.length > 0 &&
      this.automation.groupId &&
      JSON.stringify(this.automation.taskMapping) != '{}';
  }
}
